import React from 'react';

import FormRow from '../../../app/components/FormRow';
import TeamSelector from '../Selects/TeamSelector';
import { Option } from '../Selects/Selector';
import { useTranslation } from '../../../common/hooks/useTranslation';
import {
  GetDictionaryDto,
  GetPositionSpecialistTeamDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';

import {
  getPositionSpecialistTeamOptions,
  hasPositionSpecialistTeams,
} from './SpecialistTeamPhaseUtils';

export interface ImportTeamValue {
  id: string | undefined;
  name?: string;
}

export interface ImportPathPhaseValue {
  id: string | undefined;
  value?: string;
  valueEn?: string;
}

interface ImportTeamFieldProps {
  positionSpecialistTeams?: GetPositionSpecialistTeamDto[];
  companyId?: string;
  pathPhaseDictionaries?: GetDictionaryDto[];
  pathPhaseDictionaryId?: string;
  teamId?: string;
  onTeamChange: (team: ImportTeamValue) => void;
  onPathPhaseChange: (pathPhase: ImportPathPhaseValue) => void;
}

// Pole zespołu w mapowaniu importów (PAE, UMP).
// Pozycja z zespołami specjalistycznymi -> zespoły pozycji (z uwzględnieniem fazy),
// bez -> aktywne zespoły spółki. Dla użytkownika to jedno pole.
export const ImportTeamField: React.FC<ImportTeamFieldProps> = props => {
  const { t, tk } = useTranslation('projectLng');
  const positionSpecialistTeams = props.positionSpecialistTeams;

  const onSpecialistTeamChange = (option: Option) => {
    props.onTeamChange({ id: option?.value, name: option?.label });
    const teamPathPhaseId = positionSpecialistTeams?.find(
      c => c.teamId === option?.value,
    )?.team?.pathPhaseId;
    const dict = teamPathPhaseId
      ? props.pathPhaseDictionaries?.find(d => d.id === teamPathPhaseId)
      : undefined;
    if (dict) {
      props.onPathPhaseChange({
        id: dict.id,
        value: dict.value,
        valueEn: dict.valueEn,
      });
    }
  };

  return (
    <FormRow controlId="specialistTeam" label={t(tk.estimates.deliveryTeam)}>
      {hasPositionSpecialistTeams(positionSpecialistTeams) ? (
        <TeamSelector
          allowableValues={
            getPositionSpecialistTeamOptions(
              positionSpecialistTeams,
              props.pathPhaseDictionaryId,
            ).teams
          }
          value={props.teamId || undefined}
          clearable={true}
          onChange={option => onSpecialistTeamChange(option as Option)}
        />
      ) : (
        <TeamSelector
          companyId={props.companyId}
          value={props.teamId || undefined}
          clearable={true}
          onChange={option => {
            const newOption = option as Option;
            props.onTeamChange({
              id: newOption?.value,
              name: newOption?.label,
            });
          }}
        />
      )}
    </FormRow>
  );
};
